import { render, staticRenderFns } from "./EVMWallet.vue?vue&type=template&id=454252f4&scoped=true&"
import script from "./EVMWallet.vue?vue&type=script&lang=js&"
export * from "./EVMWallet.vue?vue&type=script&lang=js&"
import style0 from "./EVMWallet.vue?vue&type=style&index=0&id=454252f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454252f4",
  null
  
)

export default component.exports